import JsBridge from "xfpyh5bridge";
export const xfpyappH5Js = JsBridge.xfpyappH5Js;
export const xfpyappJsBridge = JsBridge.xfpyappJsBridge;
export default JsBridge;
